import { UuidGenerator } from '../uuid-generator';
var Transaction = /** @class */ (function () {
    function Transaction(price, item) {
        this.transactionID = UuidGenerator.UUID();
        this.price = price;
        this.item = item;
    }
    Transaction.prototype.getTransactionID = function () {
        return this.transactionID;
    };
    Transaction.prototype.getPrice = function () {
        return this.price;
    };
    Transaction.prototype.getItem = function () {
        return this.item;
    };
    return Transaction;
}());
export { Transaction };
